import { put, takeLatest, fork, call } from "redux-saga/effects";
import {
  CSVDownloadQuestionResponse,
  ActionType,
  IQuestionDownloadData,
} from "models/questionnaires/downloadCSVQuestion";
import { httpStatus } from "configs/httpStatus";
import { downloadCSVQuestion } from "services/questionnaires";
import {
  handleSuccesAction,
  handleErrorAction,
} from "./downloadCSVQuestionActions";

function* downloadCSVQuestionSaga({
  payload,
}: {
  payload: IQuestionDownloadData;
}) {
  try {
    const response: CSVDownloadQuestionResponse = yield call(
      downloadCSVQuestion,
      payload
    );
    if (response.status === httpStatus.StatusOK) {
      yield put(handleSuccesAction(response));
    } else {
      yield put(handleErrorAction(response.message || ""));
    }
  } catch (error) {
    yield put(handleErrorAction("error"));
  }
}
function* onDownloadCSVQuestionWatcher() {
  yield takeLatest(
    ActionType.CSV_DOWNLOAD_QUESTION as any,
    downloadCSVQuestionSaga
  );
}

export default [fork(onDownloadCSVQuestionWatcher)];
